<div *ngIf="address">
  {{ address.streetLine1 }}
  <br *ngIf="address.streetLine1" />
  {{ address.streetLine2 }}
  <br *ngIf="address.streetLine2" />
  {{ address.city }}<span *ngIf="address.city">, </span> {{ address.state?.code }}{{ address.province?.name }}
  {{ address.country?.code !== 'USA' ? address.country?.name : '' }}
  {{ address.zip }}
</div>
